import {
  SET_DISPLAY_CONTENT,
  SET_LANDER_URL,
  AGENCY_ACCOUNT,
  FORM_DATA,
  FORM_ERROR,
  SEARCH_CHECKOUT,
  CHECKOUT_LOADING,
  CHECKOUT_DATA,
  CHECKOUT_ERROR,
  GET_CAMPAIGN,
  GET_CAMPAIGNS,
  CAMPAIGN_ERROR,
  RESET_CAMPAIGN,
} from "../types";

const CampaignReducer = (state, action) => {
  switch (action.type) {
    case SET_DISPLAY_CONTENT:
      return { ...state, display_content: action.payload };

    case SET_LANDER_URL:
      return { ...state, lander_url: action.payload };

    case AGENCY_ACCOUNT:
      return { ...state, agency_account: action.payload };

    case RESET_CAMPAIGN:
      return {
        ...state,
        form_data: action.payload.form_data,
        checkout_data: action.payload.checkout_data,
      };

    case FORM_DATA:
      return { ...state, form_data: { ...state.form_data, ...action.payload } };

    case FORM_ERROR:
      return { ...state, form_error: action.payload };

    case SEARCH_CHECKOUT:
      return {
        ...state,
        selected_checkout: action.payload.selected_checkout,
        checkout_data: action.payload.data,
        checkout_loading: false,
      };

    case CHECKOUT_LOADING:
      return { ...state, checkout_loading: true };

    case CHECKOUT_DATA:
      return { ...state, checkout_data: action.payload };

    case CHECKOUT_ERROR:
      return { ...state, checkout_error: action.payload };

    case GET_CAMPAIGN:
      return {
        ...state,
        form_data: action.payload.campaign,
        selected_campaign: JSON.parse(JSON.stringify(action.payload.campaign)),
      };

    case GET_CAMPAIGNS:
      return {
        ...state,
        campaigns: action.payload.campaigns,
        campaigns_count: action.payload.total,
      };

    case CAMPAIGN_ERROR:
      return { ...state, campaign_error: action.payload };

    default:
      return state;
  }
};

export default CampaignReducer;
